import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import AppSubSections from "../../utils/AppSubSections";
import ButtonInfo from "../common/button/ButtonInfo";
import AppIcons from "../../utils/AppIcons";
import { useApiClient } from "../../contexts/ApiClientContext";
import Loading from "../common/Loading";
import AnnexData from "../../model/AnnexData";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import TimeUtil from "../../utils/TimeUtil";

interface IAnnexDataListElementProps {
  data: AnnexData;
  canEdit: boolean;
}

function AnnexDataListElement({ data, canEdit }: IAnnexDataListElementProps) {
  // reference to the navigator
  const navigate = useNavigate();
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // manage data loading animation
  const [loading, setLoading] = useState(true);

  // load record data from the server
  useEffect(() => {
    //get the data to display

    setLoading(false);
  }, [apiClient]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div
      className="details-grid-element"
      onClick={() => {
        navigate(
          SETTINGS.get_path({
            section: AppSections.ANNEXDATA,
            id: data.id!,
            subsection: AppSubSections.VIEW,
          }),
        );
      }}
    >
      <div className="details-grid-content">
        <div className="details-grid-description">
          <div className="items-start">
            <h3 className="mr-4">{data.title}</h3>
            {canEdit && (
              <Button
                label="Edit"
                purpose={ButtonAction.EDIT}
                type={ButtonType.ICON}
                className="mx-0 ml-2 absolute right-0 top-2"
                onClick={() =>
                  navigate(
                    SETTINGS.get_path({
                      section: AppSections.ANNEXDATA,
                      id: data.id,
                      subsection: AppSubSections.EDIT,
                    }),
                  )
                }
              />
            )}
          </div>
          <p className="text-gray-700 text-md mb-4">{data.content}</p>
        </div>
        <div className="details-grid-statistics">
          <ButtonInfo>
            {AppIcons.E3D}
            <span>{data.docs?.length}</span>{" "}
            {data.docs?.length === 1 ? "file" : "files"}
          </ButtonInfo>
          <ButtonInfo>
            {AppIcons.CLOCK}
            {TimeUtil.display_date(data.timestamp)}
          </ButtonInfo>
          {/*<ButtonInfo>
            {AppIcons.DOCUMENTS}
            {getDocumentCategoryString(data.category)}
          </ButtonInfo>*/}
        </div>
      </div>
    </div>
  );
}

export default AnnexDataListElement;
